/* unplugin-vue-components disabled */import script from "./JsonXmlPage.vue?vue&type=script&setup=true&lang=js"
export * from "./JsonXmlPage.vue?vue&type=script&setup=true&lang=js"

import "./JsonXmlPage.vue?vue&type=style&index=0&id=196e0896&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-196e0896"]])

export default __exports__